import React from 'react';
import PropTypes from 'prop-types';
import AppStore from '../stores/AppStore';
import TemplateData from '../utility/getTemplateData';
import { trackConfirmationPageIM, trackPSLContentShow } from '../fpti/fpti';
import isPslCountry from '../utility/israelPsl';
import { isGNC } from '../utility/productIntegrationUtils';

const PAGE_TRACK_TAG = 'main:donate:wps:';

export default function withPageTrack(WrappedComponent, flow, result) {
  const PageTrackComponent = class extends React.Component {
    static propTypes = {
      history: PropTypes.shape({
        listen: PropTypes.func,
        push: PropTypes.func,
      }),
      location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
      }),
    };
    componentDidMount() {
      const confData = AppStore.getConfirmation() || {};
      let isGuestUpgrade = false;
      let updatedFlow = flow;
      let updatedResult = result;

      if (flow !== 'member') {
        isGuestUpgrade =
          confData.showAccountOverview ||
          confData.signUpSuccess ||
          TemplateData.fptPageName === 'guestULSignUp';

        if (TemplateData.onboardingEnabled) {
          updatedFlow = 'signup';
        }
      }

      if (isGuestUpgrade) {
        updatedResult = 'upgrade';
      }

      const tag = `${PAGE_TRACK_TAG}${updatedFlow}:${updatedResult}`;
      const eventData = {
        isSignUp: isGuestUpgrade,
        pageSpec: {
          pgrp: tag,
          page: `${tag}:web::`,
          tmpl: `${tag}:web::`,
        },
        flow,
        confirmationData: confData,
      };
      trackConfirmationPageIM(eventData);

      const rpStatus = AppStore.getDonationRecurring() === 'checked';
      if (isPslCountry() && !isGNC() && !rpStatus) {
        trackPSLContentShow({
          ...eventData,
          status: confData.isOfacPending ? 'ofac' : result,
        });
      }

      // Redundant push to handle a race condition during unmount and navigation, so the listener can be cleared.
      this.props.history.push(
        this.props.location.pathname + this.props.location.search
      );

      if (
        this.props.history &&
        typeof this.props.history.listen === 'function'
      ) {
        this.unlisten = this.props.history.listen((location, action) => {
          if (action === 'POP') {
            const token = TemplateData.token;
            const TARGET_ROUTE = `/donate?token=${token}`;
            if (location.pathname !== TARGET_ROUTE && token) {
              window.location.href = TARGET_ROUTE;
            }
          }
        });
      }
    }
    componentWillUnmount() {
      if (this.unlisten) {
        this.unlisten();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return PageTrackComponent;
}
